function linkFun (link){
    return function(e){
        if(link) {
            location.href = link;
        }
    }
}

export default {
    install(Vue,options){
        Vue.directive('link', {
            bind (el, binding, vnode) {
                const link =  binding.value;
                el.addEventListener('click',linkFun(link))

            },
            unbind(el, binding, vnode) {
                el.removeEventListener('click',linkFun)
            }
          })
    }
}